import {
  AkaAdviceCheckboxes,
  AkaDisabilityAdviceFormValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import {
  AdditionalRestriction,
  CoverageNeed,
  ProductCoverageName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";
import {
  getPayment,
  isDisplayedAndChecked,
} from "Store/akaAdvice/interfaces/getters";
import { getAdviceValueOrMinPayout } from "./utils";

import { OneTimePaymentAdvisorChoice } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import {
  AKA_GROUP_LIFE_INCAP_DEFAULT_G_VALUE,
  AKA_GROUP_LIFE_TIME_DEFAULT_G_VALUE,
} from "Components/Features/CheckPrice/Products/Advice/adviceConstants";

export const mapToDisabilityFormValues = (
  isAdvisor: boolean,
  need: CoverageNeed,
): Partial<AkaDisabilityAdviceFormValues> => {
  const incapacityOfWorkCheckbox = isDisplayedAndChecked(
    need,
    ProductCoverageName.AKA_GROUP_LIFE_INSURED_INCAPACITY_OF_WORK,
  );
  const timeLimitedDisabilityInterestCheckbox = isDisplayedAndChecked(
    need,
    ProductCoverageName.AKA_GROUP_LIFE_INSURED_TIME_LIMITED_DISABILITY_INTEREST,
  );
  const disabilityInsuredSumCheckbox = isDisplayedAndChecked(
    need,
    ProductCoverageName.DISABILITY_FLEX_PENSION,
  );

  return {
    [AkaAdviceCheckboxes.DISABILITY_CHECKBOX]:
      incapacityOfWorkCheckbox ||
      timeLimitedDisabilityInterestCheckbox ||
      disabilityInsuredSumCheckbox,

    incapacityOfWorkCheckbox,
    incapacityOfWorkGLevel: String(
      getAdviceValueOrMinPayout(
        need,
        ProductCoverageName.AKA_GROUP_LIFE_INSURED_INCAPACITY_OF_WORK,
        isAdvisor,
      ),
    ),
    timeLimitedDisabilityInterestCheckbox,
    timeLimitedDisabilityInterestGLevel: String(
      getAdviceValueOrMinPayout(
        need,
        ProductCoverageName.AKA_GROUP_LIFE_INSURED_TIME_LIMITED_DISABILITY_INTEREST,
        isAdvisor,
      ),
    ),

    incapacityOfWorkCoInsuredCheckbox: false,
    incapacityOfWorkCoInsuredGLevel: String(
      AKA_GROUP_LIFE_INCAP_DEFAULT_G_VALUE,
    ),
    timeLimitedDisabilityInterestCoInsuredCheckbox: false,
    timeLimitedDisabilityInterestCoInsuredGLevel: String(
      AKA_GROUP_LIFE_TIME_DEFAULT_G_VALUE,
    ),

    disabilityInsuredSumCheckbox,
    disabilityInsuredSumSlider: getAdviceValueOrMinPayout(
      need,
      ProductCoverageName.DISABILITY_FLEX_PENSION,
      isAdvisor,
    ),
    disabilityPaymentAfter3Months: getPayment(
      need,
      ProductCoverageName.DISABILITY_FLEX_PENSION,
    ).restrictions.additionalRestrictions.includes(
      AdditionalRestriction.ELIGIBLE_FOR_PAYMENT_AFTER_3_MONTHS,
    )
      ? false
      : undefined,

    disabilityOneTimePaymentCheckbox: isDisplayedAndChecked(
      need,
      ProductCoverageName.DISABILITY_FLEX_CAPITAL,
    ),
    disabilityOneTimePaymentValue: getAdviceValueOrMinPayout(
      need,
      ProductCoverageName.DISABILITY_FLEX_CAPITAL,
      isAdvisor,
    ),

    disabilityOneTimePaymentAdvisorChoice: isDisplayedAndChecked(
      need,
      ProductCoverageName.DISABILITY_FLEX_CAPITAL,
    )
      ? OneTimePaymentAdvisorChoice.ADVICED_ONE_TIME_PAYMENT
      : OneTimePaymentAdvisorChoice.NO_ONE_TIME_PAYMENT,
    disabilityOneTimePaymentAdvisorValue: undefined,
    disabilityAdviceComment: undefined,
  };
};
